import { createFileRoute } from '@tanstack/react-router'
import { HomepageSectionsPage } from '@/features/homepage-sections'

export const Route = createFileRoute('/_authenticated/homepage-sections/')({
  component: HomepageSectionsPage,
})
